import { Children } from 'react';

import { MainContentProvider, useIsInsideMainContent } from '@/components/accessibility/MainContent';
import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';

import { Grid, Wrapper } from './styles';
import { GridWrapperProps } from './types';

const GridWrapper = ({
	el = 'div',
	gridEl = 'div',
	id,
	columns,
	className,
	children,
	allowOverflow = false,
	alignLeft = false,
}: GridWrapperProps) => {
	const numColumns = columns || Children.count(children);
	const gridTemplateColumns = `repeat(${numColumns}, minmax(0, 1fr))`;
	const isInsideMainContent = useIsInsideMainContent();
	const isMainContent = id === MAIN_CONTENT_ID && !isInsideMainContent;
	// Inside another main landmark the skip-to-main id would be a duplicate, so it is dropped.
	const wrapperId = id === MAIN_CONTENT_ID && !isMainContent ? undefined : id;

	const wrapper = (
		<Wrapper
			alignLeft={alignLeft}
			allowOverflow={allowOverflow}
			as={isMainContent ? 'main' : el}
			id={wrapperId}
		>
			<Grid className={className} columns={gridTemplateColumns} as={gridEl}>
				{children}
			</Grid>
		</Wrapper>
	);

	return isMainContent ? <MainContentProvider value>{wrapper}</MainContentProvider> : wrapper;
};

export default GridWrapper;
